const BHMS_GRID_CONFIG_LIST = [
  {
    grid_config: {
      rows: 1,
      columns: 5,
    },
    data_config: {
      data_mapping: "grid", // "grid" | "cell"
      key_prefix: "B",
      value_prefix: "Bank ",
      value_unit: "V",
      value_thresold: 9.5,
      disabled_cell_bg_color: "lightgray",
      threshold_exceeded_bg_color: "lightgreen",
      threshold_not_exceeded_bg_color: "red",
    },
    number_of_horizontal_grids: 1,
    number_of_vertical_grids: 6,
    type: "horizontal", // "horizontal" | "vertical" | "random"
    is_spiral: false,
    starting_point: "topLeft", // "topLeft" | "topRight" | "bottomLeft" | "bottomRight"
  },
  {
    grid_config: {
      rows: 1,
      columns: 5,
    },
    data_config: {
      data_mapping: "grid", // "grid" | "cell"
      key_prefix: "B",
      value_prefix: "Bank ",
      value_unit: "V",
      value_thresold: 9.5,
      disabled_cell_bg_color: "lightgray",
      threshold_exceeded_bg_color: "lightgreen",
      threshold_not_exceeded_bg_color: "red",
      cell_start_index: 31,
      grid_start_index: 7,
    },
    number_of_horizontal_grids: 1,
    number_of_vertical_grids: 5,
    type: "horizontal", // "horizontal" | "vertical" | "random"
    is_spiral: false,
    starting_point: "topLeft", // "topLeft" | "topRight" | "bottomLeft" | "bottomRight"
  },
];

const BHMS_CYZ_GRID_CONFIG_LIST = [
  {
    grid_config: {
      rows: 1,
      columns: 5,
    },
    data_config: {
      data_mapping: "grid", // "grid" | "cell"
      key_prefix: "B",
      value_prefix: "Bank ",
      value_unit: "V",
      value_thresold: 9.5,
      disabled_cell_bg_color: "lightgray",
      threshold_exceeded_bg_color: "lightgreen",
      threshold_not_exceeded_bg_color: "red",
    },
    number_of_horizontal_grids: 1,
    number_of_vertical_grids: 6,
    type: "horizontal", // "horizontal" | "vertical" | "random"
    is_spiral: false,
    starting_point: "topLeft", // "topLeft" | "topRight" | "bottomLeft" | "bottomRight"
  },
  {
    grid_config: {
      rows: 1,
      columns: 5,
    },
    data_config: {
      data_mapping: "grid", // "grid" | "cell"
      key_prefix: "B",
      value_prefix: "Bank ",
      value_unit: "V",
      value_thresold: 9.5,
      disabled_cell_bg_color: "lightgray",
      threshold_exceeded_bg_color: "lightgreen",
      threshold_not_exceeded_bg_color: "red",
      cell_start_index: 31,
      grid_start_index: 7,
      threshold_config: {
        B12: 3.8,
      },
    },
    total_cells: 27,
    number_of_horizontal_grids: 1,
    number_of_vertical_grids: 6,
    type: "horizontal", // "horizontal" | "vertical" | "random"
    is_spiral: false,
    starting_point: "topLeft", // "topLeft" | "topRight" | "bottomLeft" | "bottomRight"
  },
];

const BHMS_CELL_CONFIG_LIST = [
  {
    grid_config: {
      rows: 1,
      columns: 5,
    },
    data_config: {
      data_mapping: "cell", // "grid" | "cell"
      key_prefix: "B",
      value_prefix: "Bank ",
      value_unit: "V",
      value_thresold: 1.9,
      disabled_cell_bg_color: "lightgray",
      threshold_exceeded_bg_color: "lightgreen",
      threshold_not_exceeded_bg_color: "red",
    },
    number_of_horizontal_grids: 1,
    number_of_vertical_grids: 6,
    type: "horizontal", // "horizontal" | "vertical" | "random"
    is_spiral: false,
    starting_point: "topLeft", // "topLeft" | "topRight" | "bottomLeft" | "bottomRight"
  },
  {
    grid_config: {
      rows: 1,
      columns: 5,
    },
    data_config: {
      data_mapping: "cell", // "grid" | "cell"
      key_prefix: "B",
      value_prefix: "Bank ",
      value_unit: "V",
      value_thresold: 1.9,
      disabled_cell_bg_color: "lightgray",
      threshold_exceeded_bg_color: "lightgreen",
      threshold_not_exceeded_bg_color: "red",
      cell_start_index: 31,
      grid_start_index: 7,
    },
    number_of_horizontal_grids: 1,
    number_of_vertical_grids: 5,
    type: "horizontal", // "horizontal" | "vertical" | "random"
    is_spiral: false,
    starting_point: "topLeft", // "topLeft" | "topRight" | "bottomLeft" | "bottomRight"
  },
];

export enum BhmsConfigType {
  grid = "bhms_grid_config",
  cell = "bhms_cell_config",
  cyz_grid = "bhms_cyz_grid_config",
}

export const BHMS_STATION_CONFIG_MAP = {
  VS: BhmsConfigType.grid,
  MIU: BhmsConfigType.cell,
  MPR: BhmsConfigType.grid,
  BPNL: BhmsConfigType.grid,
  CYZ: BhmsConfigType.cyz_grid,
};

export function getBhmsInfo(type: BhmsConfigType = BhmsConfigType.cell, device_data: Record<string, string>) {
  let charging_current: string | number = 0;
  let discharge_current: string | number = 0;
  let bank_voltage: string | number = 0;
  let config_list: any[] = [];

  function getGridData() {
    const IBAT = device_data.IBAT && Number(device_data.IBAT) ? Number(device_data.IBAT) / 1000 : 0;
    const VBAT = device_data.VBAT && Number(device_data.VBAT) ? Number(device_data.VBAT) / 1000 : 0;

    charging_current = IBAT && IBAT > 0 ? IBAT.toFixed(2) : 0;
    discharge_current = IBAT && IBAT < 0 ? Math.abs(IBAT).toFixed(2) : 0;
    bank_voltage = VBAT ? VBAT.toFixed(2) : 0;
  }

  switch (type) {
    case BhmsConfigType.grid: {
      getGridData();
      config_list = BHMS_GRID_CONFIG_LIST;
      break;
    }
    case BhmsConfigType.cyz_grid: {
      getGridData();
      config_list = BHMS_CYZ_GRID_CONFIG_LIST;
      break;
    }
    case BhmsConfigType.cell: {
      const IC = device_data.IC && Number(device_data.IC) ? Number(device_data.IC) / 1000 : 0;
      const ID = device_data.ID && Number(device_data.ID) ? Number(device_data.ID) / 1000 : 0;
      const VBAT = device_data.VBAT && Number(device_data.VBAT) ? Number(device_data.VBAT) / 1000 : 0;

      charging_current = IC ? IC.toFixed(2) : 0;
      discharge_current = ID ? ID.toFixed(2) : 0;
      bank_voltage = VBAT ? VBAT.toFixed(2) : 0;

      config_list = BHMS_CELL_CONFIG_LIST;
    }
  }

  return {
    info: [
      { title: "Name", text: device_data.NAME },
      { title: "Bank Voltage", text: bank_voltage + " V" },
      { title: "Charging Current", text: charging_current + " A" },
      { title: "Discharge Current", text: discharge_current + " A" },
    ],
    config_list,
  };
}
